import React, { useCallback } from "react";
import { split } from "lodash";
import { Facet } from "@linkfluence/models/facet";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { DemographicCard } from "@radarly/models/cards";
import { createClauseFromInnerClause } from "@radarly/models/clause/creator";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { refineClauseWithInnerClause } from "@radarly/models/clause/refiner";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import Demographic from "@radarly/shared/widgets/demographic/pyramid";
import { useFragment } from "../fragment";
import { CardProps } from "../model";

const RadarlyDemographicCards = ({
  card,
  openPostsPanel,
  timezone,
  forceReload,
  nowDate,
  ...props
}: CardProps<DemographicCard>) => {
  const project = useCurrentProject();
  const fragment = useFragment(
    card.fragments[0],
    props.clause,
    props.from,
    props.to,
    timezone
  );
  const dataviz = card.dataviz;
  const metric = fragment.request.aggs.genders.aggs.age.metrics[0];
  const title = card.title;

  const onClickItem = useCallback(
    (range: string, gender?: string) => {
      const { from, to } = getDateFromClause(fragment.request.query);
      const [rangeFrom, rangeTo] = split(range, "-");
      const focusClause = createClauseFromInnerClause({
        birthDate: {
          lt: `now-${rangeFrom}y`,
          gt: `now-${rangeTo}y`,
        },
      });
      openPostsPanel({
        clause: fragment.request.query,
        period: {
          from,
          to,
        },
        title,
        timezone,
        focusClause: !!gender
          ? refineClauseWithInnerClause(focusClause, {
              [Facet.Genders]: [gender],
            })
          : focusClause,
      });
    },
    [fragment.request.query, openPostsPanel, timezone, title]
  );
  return (
    <Tile
      title={title}
      height={props.height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric metric={metric} />,
          ]}
        />
      }
      clause={fragment.request.query}
      isPNG
    >
      <Demographic
        fragment={fragment}
        project={project.id}
        dataviz={dataviz}
        onClickRangeGender={openPostsPanel ? onClickItem : null}
        onClickRange={openPostsPanel ? onClickItem : null}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyDemographicCards;
